import "bootstrap"
require("../../src/content/themes/association-wordpress-theme/js/main.js");
